import * as React from 'react';
//import * as Sebrae from '@sebrae/react-core';
import {
  StyledJumbotron,
  PaddingContainer,
} from '../../components/shared/jumbotron/jumbotron-styled';
import * as Sebrae from '@sebrae/react-core';
import {
  BaSeTheme,
  BaSeContainer,
  BaSeHeading2,
  BaSeHeading5,
  BaSeDialogContext,
  BaSeLoading,
} from '@base/react';
import { JumbotronMensagens } from './gerar-certificados-lote-styled';
import { ImportarCertificados } from '../../components/certificados-em-lote/importar-certificados';
import { CERTIFICADO_ENDPOINT } from '../../hooks/constants';
import { RelatorioCertificadosLote } from '../../components/certificados-em-lote/relatorio-certificados-lote';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const GerarCertificadosLotePage = () => {
  const [isImportFiles, setIsImportFiles] = React.useState(true);
  const [files, setFiles] = React.useState([]);
  const [isReport, setIsReport] = React.useState(false);
  const [responseFiles, setResponseFiles] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [notifyMessage, setNotifyMessage] = React.useState(null);

  const { showNotification } = React.useContext(BaSeDialogContext);
  const { backendPost } = Sebrae.useBackend();
  const { azulSebrae30 } = BaSeTheme.colors.institucionais;

  const notify = React.useCallback((lote, typeNotify) => {
    const pluralError = lote.totalErro > 1 ? 's' : '';
    const pluralSuccess = lote.totalSucesso > 1 ? 's' : '';
    const messageWithError = `Identificamos ${
      lote.totalErro
    } registro${pluralError} com erro que não ${
      lote.totalErro > 1 ? 'foram' : 'foi'
    } gerado${pluralError}. \nConfira o relatório de erro e corrija as informações do arquivo para enviar novamente!`;

    const messageSuccess = `Identificamos ${lote.totalSucesso} registro${pluralSuccess} enviado${pluralSuccess} com sucesso`;

    const message = {
      attention: {
        message: 'Atenção!',
        supportMessage: messageWithError,
        color: 'attention',
      },
      confirmation: {
        message: 'Envio finalizado',
        supportMessage: messageSuccess,
        color: 'confirmation',
      },
      destructive: {
        message: 'Nenhum registro enviado!',
        supportMessage: messageWithError,
        color: 'destructive',
      },
      default: {
        message: 'Atenção!!!',
        color: 'attention',
      },
    };
    setNotifyMessage(message?.[typeNotify] ?? message.default);
  }, []);

  // eslint-disable-next-line sonarjs/cognitive-complexity
  const sendFiles = React.useCallback(() => {
    if (files.length < 1) {
      showNotification({
        message: `Adicione pelo menos um arquivo`,
        color: 'attention',
      });
      return;
    }
    setIsImportFiles(false);
    setIsLoading(true);
    setIsLoading(true);
    const postData = new FormData();

    files.map((file) => postData.append('files', file));

    backendPost(`${CERTIFICADO_ENDPOINT}/lote`, postData)
      .then((resp) => {
        const { totalErro, totalSucesso, total } = resp;
        const allErro = totalErro === total;
        const allSuccess = totalSucesso === total;
        const typeNotify = allSuccess
          ? 'confirmation'
          : allErro
          ? 'destructive'
          : 'attention';

        setResponseFiles(resp);
        setIsImportFiles(false);
        notify(resp, typeNotify);
      })
      .catch((error) => {
        setIsImportFiles(true);
        setIsReport(false);
        showNotification({
          message: `Erro ao enviar arquivo`,
          supportMessage: error.message,
          color: 'destructive',
        });
      })
      .finally(() => setIsLoading(false));
  }, [backendPost, files, notify, showNotification]);

  const TitleImport = ({ subTitle }) => (
    <>
      <div>
        <BaSeHeading2 color={azulSebrae30}>
          Gerar certificados em lote
        </BaSeHeading2>
        <BaSeHeading5 color={azulSebrae30}>{subTitle}</BaSeHeading5>
      </div>
    </>
  );

  const voltar = React.useCallback(() => {
    setIsReport(false);
    setIsImportFiles(true);
  }, []);

  return (
    <div>
      <StyledJumbotron backgroundColor={BaSeTheme.colors.defaultColors.white}>
        <BaSeContainer delimitedOnBreakpoint="desktop">
          <JumbotronMensagens>
            {isImportFiles && <TitleImport subTitle="Importação" />}
            {isReport && <TitleImport subTitle="Relatório de geração" />}
          </JumbotronMensagens>
        </BaSeContainer>
      </StyledJumbotron>
      <div style={{ marginBotton: 20 }}>
        <BaSeContainer delimitedOnBreakpoint="desktop">
          {isLoading ? (
            <div
              style={{
                position: 'relative',
                padding: '10em',
                width: 400,
                height: 200,
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              <BaSeLoading
                text="Aguarde um momento..."
                roundedCorner={true}
                shadowLevel={8}
              />
            </div>
          ) : (
            <PaddingContainer>
              {isImportFiles && (
                <ImportarCertificados
                  setIsImportFiles={setIsImportFiles}
                  setIsReport={setIsReport}
                  setFiles={setFiles}
                  sendFiles={sendFiles}
                />
              )}
              {isReport && (
                <RelatorioCertificadosLote
                  responseFiles={responseFiles}
                  notifyMessage={notifyMessage}
                  setIsReport={voltar}
                />
              )}
            </PaddingContainer>
          )}
        </BaSeContainer>
      </div>
    </div>
  );
};
